export const groupGridPropsAreEqual = (previous, next) =>
  previous.gridData === next.gridData &&
  previous.gridColumns === next.gridColumns &&
  previous.rowSelection === next.rowSelection &&
  previous.editableColumns === next.editableColumns &&
  previous.stickyHeaders === next.stickyHeaders &&
  previous.headersVisibility === next.headersVisibility &&
  previous.autoRowHeights === next.autoRowHeights &&
  previous.style?.height === next.style?.height &&
  previous.style?.minHeight === next.style?.minHeight;

